import {
  createAppI18n,
  defaultLang,
  loadLocalTranslations,
  registerI18nInstance
} from '@shared/locales'

export const organizationI18n = createAppI18n()

const initializeOrganizationI18n = async (lang: string) => {
  await loadLocalTranslations(organizationI18n, 'organization', lang)
}

registerI18nInstance(organizationI18n)

let lastLoadedLang: string | null = null

organizationI18n.on('languageChanged', async (newLang) => {
  if (newLang !== lastLoadedLang) {
    await initializeOrganizationI18n(newLang)
    lastLoadedLang = newLang
  }
})

const initializeDefaultLanguage = async () => {
  const lang = organizationI18n.language || defaultLang.value

  await initializeOrganizationI18n(lang)
  await organizationI18n.changeLanguage(lang)
}

initializeDefaultLanguage()
